import { Table } from 'antd'
import {
  Box,
  Button,
  Card,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from '@mui/material'
import dayjs from 'dayjs'

import {
  ONLY_DATE_FORMAT,
  ONLY_TIME_FORMAT,
} from '../../../../../constants/global'
import CircularLoading from '../../../../../components/CircularProgress'
import Pagination from '../../../../../components/Pagination'
import { IOrderMessage } from '../../../../../types/order-message'
import SearchIcon from '@mui/icons-material/Search'
import { useState } from 'react'

export interface IFilterMapped {
  page?: number
  perPage?: number
  search?: string
}

interface IOrderListTeleSaleTableProps {
  isLoading: boolean
  onUpdateSuccess?: () => void
  data?: IOrderMessage[]
  filter?: IFilterMapped
  onFilterChange?: (filter: IFilterMapped) => void
  total?: number
}

const OrderQuickCreateOldListTable = ({
  isLoading,
  filter,
  onFilterChange,
  data,
  total,
}: IOrderListTeleSaleTableProps) => {
  const [search, setSearch] = useState('')
  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'numberRow',
      key: 'numberRow',
      align: 'center' as const,
      width: 80,
      render: (numberRow: number) => {
        return (
          <Box>
            <Typography
              variant="subtitle1"
              color="text.secondary"
              textAlign={'center'}
            >
              {numberRow}
            </Typography>
          </Box>
        )
      },
    },
    {
      title: 'ข้อความ',
      dataIndex: 'message',
      key: 'message',
      align: 'left' as const,
      render: (message: string) => {
        const formattedMessage = message.split('\n').map((line, index) => {
          return (
            <span key={index}>
              {line}
              <br />
            </span>
          )
        })
        return (
          <Box sx={{ minWidth: 60 }}>
            <Typography variant="subtitle2" color="text.primary">
              {formattedMessage}
            </Typography>
          </Box>
        )
      },
    },
    {
      title: 'ORDER ID',
      dataIndex: 'order',
      key: 'order',
      align: 'center' as const,
      width: 120,
      render: (order: string) => {
        return (
          <Box>
            <Typography variant="subtitle2" color="text.secondary">
              {order}
            </Typography>
          </Box>
        )
      },
    },
    {
      title: 'โดย',
      dataIndex: 'actor',
      key: 'actor',
      align: 'center' as const,
      width: 100,
      render: (actor: string, orderMessage: IOrderMessage) => {
        return (
          <Box>
            <Typography variant="subtitle2" color="text.secondary">
              {actor}
            </Typography>
            <Typography variant="subtitle2" color="text.secondary">
              {orderMessage.telesaleBy
                ? `USER:[${orderMessage.telesaleBy}]`
                : ''}
            </Typography>
          </Box>
        )
      },
    },
    {
      title: 'วันที่เพิ่ม',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 160,
      align: 'center' as const,
      render: (createdAt: string) => {
        return (
          <Box>
            <Typography variant="subtitle2" color="text.secondary">
              {dayjs(createdAt || undefined).format(ONLY_DATE_FORMAT)}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {dayjs(createdAt || undefined).format(ONLY_TIME_FORMAT)}
            </Typography>
          </Box>
        )
      },
    },
  ]

  return (
    <>
      <CircularLoading isLoading={isLoading} />
      <Card sx={{ p: 2 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} lg={9}>
            <TextField
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              label={'ค้นหาข้อความ'}
              fullWidth
              id="search"
              name="search"
              variant="filled"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value)
              }}
            />
          </Grid>
          <Grid item xs={12} lg={3}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              size="large"
              onClick={() => onFilterChange?.({ ...filter, search })}
            >
              ค้นหา
            </Button>
          </Grid>
          <Grid item xs={12} lg={12}>
            <Table
              size={'middle'}
              columns={columns}
              scroll={{
                x: columns.reduce(
                  (pre, cur: any) => (cur.width ? cur.width + pre : pre),
                  0,
                ),
              }}
              dataSource={data?.map(
                (productTransaction: IOrderMessage, index: number) => {
                  return {
                    ...productTransaction,
                    key: index,
                    numberRow:
                      (filter?.page || 1) * (filter?.perPage || 15) +
                      index -
                      (filter?.perPage || 15) +
                      1,
                  }
                },
              )}
              bordered
              pagination={false}
            />
            <Pagination
              total={total || 0}
              current={filter?.page || 1}
              pageSize={filter?.perPage || 15}
              onChange={(page, perPage) =>
                onFilterChange?.({ ...filter, page, perPage })
              }
            />
          </Grid>
        </Grid>
      </Card>
    </>
  )
}

export default OrderQuickCreateOldListTable
